function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#00A9FF;}\r\n\t.st1{enable-background:new    ;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "refund-icon",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1506",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1505",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1127",
  className: "st0",
  d: "M18.9,5.6l-1.3,1.7c4.2,3.3,5,9.3,1.7,13.5c-3.3,4.2-9.3,5-13.5,1.7S0.9,13.2,4.1,9 c1.9-2.5,5-3.9,8.1-3.7l-1.8,1.9l1.3,1.3l2.9-3l0,0l1.3-1.3l-1.3-1.3l0,0l-3-2.9l-1.3,1.3l1.9,1.9C5.8,2.9,0.3,7.9,0,14.4 c-0.3,5.9,4,11.1,9.9,12.1c0.6,0.1,1.2,0.1,1.8,0.1c6.5,0,11.7-5.3,11.7-11.7C23.4,11.3,21.7,7.9,18.9,5.6z"
}), /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M13.5,17.2c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.4-1-0.6s-0.9-0.3-1.2-0.5s-0.6-0.4-0.9-0.6 c-0.2-0.2-0.4-0.5-0.6-0.8c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.7,0.2-1.3,0.7-1.8s1.1-0.7,1.8-0.8V8.9h1v1.4c0.7,0.1,1.3,0.4,1.8,0.9 c0.4,0.5,0.6,1.2,0.6,2h-1.8c0-0.5-0.1-0.9-0.3-1.1c-0.2-0.3-0.5-0.4-0.8-0.4c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8 c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,1,0.6c0.5,0.2,0.9,0.4,1.2,0.6c0.3,0.2,0.6,0.4,0.8,0.6c0.2,0.2,0.4,0.5,0.5,0.8 c0.1,0.3,0.2,0.6,0.2,1c0,0.7-0.2,1.3-0.7,1.8c-0.4,0.4-1.1,0.7-1.9,0.8V21h-1v-1.3c-0.9-0.1-1.5-0.4-2-0.9 C9.3,18.3,9,17.6,9,16.7h1.8c0,0.5,0.1,0.9,0.4,1.2c0.2,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,0.9-0.3S13.5,17.5,13.5,17.2z"
})))));

function SvgRefundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.4 26.6",
    style: {
      enableBackground: "new 0 0 23.4 26.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundIcon);
export default __webpack_public_path__ + "static/media/refund-icon.4e442394.svg";
export { ForwardRef as ReactComponent };